var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNexlaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 -10 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #6254ff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.86,15.85L.13,13.13c-.17-.17-.17-.45,0-.63L11.25,1.38c.89-.89,2.07-1.38,3.32-1.38s2.43.49,3.32,1.38l6.36,6.36c.17.17.17.45,0,.63l-2.73,2.73c-.17.17-.45.17-.63,0l-5.56-5.56c-.43-.43-1.12-.43-1.54,0L3.49,15.85c-.17.17-.45.17-.63,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.21,21.25c-1.2,0-2.41-.46-3.32-1.37l-6.36-6.36c-.17-.17-.17-.45,0-.63l2.73-2.73c.17-.17.45-.17.63,0l5.56,5.56c.43.43,1.12.43,1.54,0l10.4-10.4c.17-.17.45-.17.63,0l2.73,2.73c.17.17.17.45,0,.63l-11.21,11.21c-.92.92-2.12,1.37-3.32,1.37Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexlaIcon);
export default __webpack_public_path__ + "static/media/nexla-icon.e73e5d50d48450c3bb7eaea45022b617.svg";
export { ForwardRef as ReactComponent };